<template>
  <div>
    <vx-card title="Installment" v-show="!flag_new">
      <template slot="actions">
        <vs-button v-show="!flag_empty_installment && !flag_new && (permissions_update || permissions_create)"
          size="small" color="danger" type="filled" @click="cancelInstallment">Cancel</vs-button>
        <vs-button :disabled="flag_save_installment"
          v-show="(flag_empty_installment || flag_new) && (permissions_update || permissions_create)" size="small"
          color="primary" type="filled" icon="icon-save" icon-pack="feather" class="ml-2" @click="saveInstallment">{{
            largeScreenWidth ? 'Save' : '' }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col mt-6 mb-3">
          <vs-checkbox :disabled="flagDisabled" v-model="installment.type">是 PP？</vs-checkbox>
        </div>
        <div class="vx-col mt-6 mb-3">
          <vs-checkbox :disabled="flagDisabled" v-model="installment.auto_generate">Auto Generate / 自动</vs-checkbox>
        </div>
      </div>
      <div class="vx-row mb-5">
        <div class="vx-col sm:w-1/4 w-full mb-3">
          <vs-input :disabled="flagDisabled" type="number" class="w-full" label-placeholder="Pay/供"
            v-model="installment.pay_per_term" @change="generateInstallmentSchedule" />
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-3" v-if="!installment.type">
          <vs-input :disabled="flagDisabled" type="number" class="w-full" label-placeholder="Term/期"
            v-model="installment.term" @change="generateInstallmentSchedule" />
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-3">
          <vs-input :disabled="flagDisabled" type="number" class="w-full" label-placeholder="Days/日"
            v-model="installment.day_term" @change="generateInstallmentSchedule" />
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-3">
          <datepicker :disabled="flagDisabled" style="padding-top:1.1rem" :monday-first="true"
            placeholder="Start Date/开始日期" class="w-full" v-model="installment.installment_start_date" format="yyyy-MM-dd"
            @input="installment.start_date = fixDate($event)"></datepicker>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-tabs class="loan-installment">
            <vs-tab label="Detail" icon-pack="feather" icon="icon-home">
              <div class="vx-row mt-3 mb-3" v-if="installment.id !== ''">
                <div class="vx-col">
                  <!-- <vs-button size="small" color="dark" type="border" @click="extend_pp" v-show="installment.type == true && (permissions_update || permissions_create)">Extend PP</vs-button> -->
                  <!-- <vs-button v-show="loan_info.loan_status == 'COMPLETE' && (permissions_update || permissions_create)" size="small" color="primary" type="filled" class="ml-2" @click="extra_payment">Extra Payment</vs-button> -->
                  <!-- <vs-button size="small" color="primary" type="filled" class="ml-2" @click="full_payment" v-show="loan_info.loan_status !== 'COMPLETE' && (permissions_update || permissions_create)">Full Payment</vs-button> -->
                </div>
              </div>
              <div class="vx-row mt-3 mb-3" v-if="original_installment_details.length > 0"
                style="display:flex; justify-content:space-between">
                <div class="vx-col">
                  <vs-checkbox v-model="show_all_terms">Show all installment</vs-checkbox>
                </div>
                <div class="vx-col">
                  <vs-button
                    v-show="!flag_new && loan_info.loan_status == 'COMPLETE' && (permissions_update || permissions_create)"
                    size="small" color="primary" type="filled" class="ml-2" @click="extra_payment">Extra
                    Payment</vs-button>
                  <vs-button size="small" color="primary" type="border" @click="extend_pp"
                    v-show="installment.type == true && (permissions_update || permissions_create) && loan_info.loan_status !== 'COMPLETE'">Extend
                    PP</vs-button>
                </div>
              </div>
              <div class="vx-row mt-3 mb-3" style="font-size: 0.8rem;" v-show="!show_all_terms"
                :class="largeScreenWidth ? '' : 'show-overflow'">
                <div class="vx-col w-full lg:w-1/3 md:w-1/2 sm:w-full mb-base install-term"
                  v-for="(item, index) in installment_terms" :key="index">
                  <vx-card :title="'还帐日期: ' + item.due_date" :class="checkLateDate(item.due_date, item.status, 'latedate')">
                    <!-- SLOT = ACTION -->
                    <template slot="actions"
                      v-if="item.id && item.id !== '' && (permissions_update || permissions_create)">
                      <vs-dropdown v-if="item.status !== 'PAID'" vs-trigger-click class="cursor-pointer">
                        <h5 class="flex cursor-pointer">
                          <!-- Action -->
                          <feather-icon icon="MoreVerticalIcon" svgClasses="h-6 w-6" />

                          <!-- <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" class="ml-1" /> -->
                        </h5>
                        <vs-dropdown-menu class="w-32">
                          <vs-dropdown-item v-show="item.status !== 'PAID'"
                            @click="openPaymentModal(item, index, 'payment')">Pay/付款</vs-dropdown-item>
                          <vs-dropdown-item v-show="item.status !== 'PAID'"
                            @click="openPaymentModal(item, index, 'settlement')">Full Pay/全额付款</vs-dropdown-item>
                          <vs-dropdown-item @click="openPaymentModal(item, index, 'edit')">Edit/编制</vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>

                      <vs-dropdown v-else vs-trigger-click class="cursor-pointer">
                        <h5 class="flex cursor-pointer">
                          <!-- Action -->
                          <feather-icon icon="MoreVerticalIcon" svgClasses="h-6 w-6" />

                          <!-- <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" class="ml-1" /> -->
                        </h5>
                        <vs-dropdown-menu class="w-32">
                          <vs-dropdown-item @click="deleteInstallment(item, index, 'delete')"
                            style="color:red">Delete/删除</vs-dropdown-item>
                          <vs-dropdown-item @click="openPaymentModal(item, index, 'edit')">Edit/编制</vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>

                      <!-- <feather-icon v-else icon="EditIcon" svgClasses="h-6 w-6" class="text-primary" @click="openPaymentModal(item,index,'edit')"/> -->
                    </template>

                    <div>
                      <ul>
                        <li class="flex mb-3" :class="installment.auto_generate ? 'auto_generate' : 'off-auto'"
                          v-if="!installment.auto_generate">
                          <span class="inline-block font-semibold">New Date</span>
                          <div class="ml-auto flex">
                            <div class="vx-col w-full">
                              <datepicker :monday-first="true" placeholder="Start Date/开始日期" class="w-full"
                                v-model="item.due_date" format="yyyy-MM-dd" @input="item.due_date = fixDate($event)">
                              </datepicker>
                            </div>
                          </div>
                        </li>

                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">Principal</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(loan_info.loan_settlement) }}</span>
                          </div>
                        </li>
                        <hr class="mb-3">
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">应付款</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(item.installment_amount) }}</span>
                          </div>
                        </li>
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">利息</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(item.late_charge || 0) }}</span>
                          </div>
                        </li>
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">折扣</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(item.discount || 0) }}</span>
                          </div>
                        </li>
                        <hr class="mb-3">
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">总</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(total_tobe_paid(item.installment_amount, item.late_charge, item.discount))
                            }}</span>
                          </div>
                        </li>
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">付款</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(item.paid_amount || 0) }}</span>
                          </div>
                        </li>
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">付款日期</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ item.paid_date || '-' }}</span>
                          </div>
                        </li>
                        <li class="flex mb-3">
                          <span class="inline-block font-semibold">剩</span>
                          <div class="ml-auto flex -mr-1">
                            <span>{{ formatNumber(item.remaining_loan || 0) }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <template slot="footer">
                      <div class="text-center" style="min-height:35px">
                        <h4><span
                            :class="['span-' + item.status, checkLateDate(item.due_date, item.status, 'latedate')]">{{ item.status }}</span><feather-icon
                            v-show="item.status == 'PAID'" icon="CheckIcon" svgClasses="h-8 w-8" class="text-success"
                            style="position: relative; top: 7px; left: 5px;" /></h4>
                        <span>{{ !item.paid_date && item.status == 'PAID' ? 'by settlement' : '' }}</span>
                      </div>
                    </template>
                  </vx-card>
                </div>

              </div>
              <div v-show="show_all_terms" class="vx-row">
                <div class="vx-col w-full" :class="largeScreenWidth ? '' : 'show-overflow'">
                  <vs-collapse class="w-full" type="margin" accordion
                    v-for="(header, index) in original_installment_details" :key="index">

                    <vs-collapse-item class="col-full-detail">
                      <div slot="header">{{ header.start_date }} {{ header.type }} {{ header.status }}</div>
                      <table class="table table-full-detail" style="text-align:center; width:100%">
                        <thead>
                          <tr>
                            <th>Due Date</th>
                            <th>Installment</th>
                            <th>Late</th>
                            <th>Discount</th>
                            <th>Paid Date</th>
                            <th>Amount</th>
                            <th>Remaining</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, ind) in header.terms" :key="ind"
                            :class="{ 'text-muted': item.status == 'VOID', 'text-success': item.status == 'PAID', 'text-danger': checkLateDate2(item.due_date, item.status) }">
                            <th>{{ item.due_date }}</th>
                            <th>{{ formatNumber(item.installment_amount || 0) }}</th>
                            <th>{{ formatNumber(item.late_charge || 0) }}</th>
                            <th>{{ formatNumber(item.discount || 0) }}</th>
                            <th>{{ item.paid_date }}</th>
                            <th>{{ formatNumber(item.paid_amount || 0) }}</th>
                            <th>{{ formatNumber(item.remaining_loan || 0) }}</th>
                            <th>{{ item.status }}</th>
                          </tr>
                        </tbody>
                      </table>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>

              </div>

            </vs-tab>
            <vs-tab label="Attachments" icon-pack="feather" icon="icon-home">
              <div class="vx-row">
                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-full mb-base" v-for="(item, index) in picture_list"
                  :key="index">
                  <vx-card class="attachments">
                    <!-- SLOT = ACTION -->
                    <!-- <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <h5 class="flex cursor-pointer">
                              Action
                              <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" class="ml-1" />
                            </h5>
                            <vs-dropdown-menu class="w-32">
                                <vs-dropdown-item @click="delete_image(item.id, index)">Delete</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                      </template> -->
                    <div style="position:relative;">
                      <vs-button radius color="danger" style="position:absolute; top:0"
                        @click="delete_image(item.id, index)" v-if="permissions_update || permissions_create"
                        icon-pack="feather" icon="icon-trash-2"></vs-button>
                      <img :alt="item.filename" :title="item.filename" style="height: 220px; width:100%; cursor:pointer"
                        :src="item.url" @click="view_image(item.url)">
                    </div>
                  </vx-card>
                </div>

                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-full mb-base" :key="picture_list.length + 1"
                  v-show="permissions_update || permissions_create">
                  <vx-card class="attachments">
                    <vue-dropzone style="height: 220px; width:100%;" id="dropzone" ref="myVueDropzone"
                      :use-custom-slot="true" :options="dropzoneOptions" @vdropzone-sending="sendingEvent"
                      @vdropzone-complete="afterComplete">
                      <div class="dropzone-custom-content">
                        <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </vue-dropzone>
                  </vx-card>
                </div>
              </div>

              <!--  <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-full mb-base" v-if="picture_list.length == 0">
                <h3>No attachment found</h3>
              </div>   -->
            </vs-tab>

            <vs-tab label="Log History" icon-pack="feather" icon="icon-home" :disabled="!flag_log_history">
              <div class="vx-row">
                <div class="vx-col w-full" style="overflow-x:scroll">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Date</th>
                        <th>Interest</th>
                        <th>Discount</th>
                        <th>Credit</th>
                        <th>Debit</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody v-show="log_history.length == 0">
                      <tr>
                        <td colspan="7"><b>No history</b></td>
                      </tr>
                    </tbody>
                    <tbody v-show="log_history.length > 0">
                      <tr :key="index" v-for="(item, index) in log_history">
                        <td width="10%">{{ item.type }}</td>
                        <td width="20%">{{ item.date }}</td>
                        <td width="10%">{{ (item.interest == '' ? '' : formatNumber(item.interest)) }}</td>
                        <td width="10%">{{ (item.discount == '' ? '' : formatNumber(item.discount)) }}</td>
                        <td width="15%">{{ (item.credit == '' ? '' : formatNumber(item.credit)) }}</td>
                        <td width="15%">{{ (item.debit == '' ? '' : formatNumber(item.debit)) }}</td>
                        <td width="15%">{{ (item.remaining_loan == '' ? '' : formatNumber(item.remaining_loan)) }}</td>
                      </tr>
                    </tbody>
                    <tfoot v-show="log_history.length > 0">
                      <tr>
                        <td></td>
                        <td></td>
                        <td>{{ compute_total_interest }}</td>
                        <td>{{ compute_total_discount }}</td>
                        <td>{{ compute_total_credit }}</td>
                        <td>{{ compute_total_debit }}</td>
                        <td></td>
                      </tr>
                      <tr v-if="percentage !== '0.00' && percentage !== ''">
                        <td colspan="7">
                          <hr />
                        </td>
                      </tr>
                      <tr v-if="percentage !== '0.00' && percentage !== ''">
                        <td colspan="7">Calculate Percentage</td>
                      </tr>
                      <tr v-if="percentage !== '0.00' && percentage !== ''">
                        <td colspan="2">Debit-Credit</td>
                        <td><b>{{ compute_profit }}</b></td>
                        <td></td>
                        <td colspan="2">Percentage: <b>{{ percentage }}%</b></td>
                        <td><b>{{ compute_profit_percentage }}</b></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </vs-tab>

            <vs-tab label="Extra Payment" icon-pack="feather" icon="icon-home">
              <div class="vx-row">
                <div class="vx-col w-full" style="overflow-x:scroll">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th v-if="isSuperAdmin && user_info.role == 'DEVELOPER'">Created</th>
                        <th v-if="isSuperAdmin && user_info.role == 'DEVELOPER'">Updated</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-show="bonus_list.length == 0">
                      <tr>
                        <td :colspan="isSuperAdmin && user_info.role == 'DEVELOPER' ? '6' : '4'"><b>No Extra Payment</b>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-show="bonus_list.length > 0">
                      <tr :key="index" v-for="(item, index) in bonus_list">
                        <td width="15%">{{ item.paid_date }}</td>
                        <td width="15%">{{ item.paid_amount }}</td>
                        <td width="15%">{{ item.status }}</td>
                        <td width="20%" v-if="isSuperAdmin && user_info.role == 'DEVELOPER'">{{
                          formatDate(item.created_at) }}</td>
                        <td width="20%" v-if="isSuperAdmin && user_info.role == 'DEVELOPER'">{{
                          formatDate(item.updated_at) }}</td>
                        <td width="20%">
                          <vs-button size="small" type="border" @click="editExtra(index)">Edit</vs-button>
                          <vs-button size="small" color="danger" type="filled" @click="removeExtra(item.id)">X</vs-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>

          <vs-popup title="Attachment detail" :active.sync="flag_showImage" class="img-detail">
            <img style="max-width:100%" :src="viewed_image_url">
          </vs-popup>

          <vs-popup :title="paymentModal_title" :active.sync="flag_paymentModal">
            <div class="vx-row">
              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full"
                v-if="modal_payment.mode !== 'settlement' && modal_payment.mode !== 'extra'">
                <vs-input :readonly="modal_payment.mode !== 'edit'" :disabled="modal_payment.mode !== 'edit'"
                  :class="['w-full', modal_payment.mode == 'edit' ? 'inputcss' : '']" label-placeholder="Schedule/期数"
                  v-model="modal_payment.due_date" />
              </div>
              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full"
                v-if="modal_payment.mode !== 'settlement' && modal_payment.mode !== 'extra'">
                <vs-input :readonly="modal_payment.mode !== 'edit'" :disabled="modal_payment.mode !== 'edit'"
                  :class="['w-full', modal_payment.mode == 'edit' ? 'inputcss' : '']" label-placeholder="Amount Due/应付款"
                  v-model="modal_payment.amount_due" />
              </div>

              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full"
                v-if="modal_payment.mode !== 'settlement' && modal_payment.mode !== 'edit' && modal_payment.mode !== 'extra'">
                <vs-input :readonly="modal_payment.mode !== 'edit'" :disabled="modal_payment.mode !== 'edit'"
                  :class="['w-full', modal_payment.mode == 'edit' ? 'inputcss' : '']" label-placeholder="Initial"
                  v-model="initialAmt" />
              </div>

              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full"
                v-show="modal_payment.mode !== 'settlement' && modal_payment.mode !== 'edit'">
                <vs-input readonly disabled class="w-full" label-placeholder="Settlement/总数"
                  v-model="compute_settlement" />
              </div>

              <vs-divider v-show="modal_payment.mode !== 'settlement'" />

              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full" v-show="modal_payment.mode !== 'extra'">
                <vs-input class="w-full inputcss" type='number' label-placeholder="Interest/利息"
                  v-model="modal_payment.interest" />
              </div>
              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full" v-show="modal_payment.mode !== 'extra'">
                <vs-input class="w-full inputcss" type='number' label-placeholder="Discount/折扣"
                  v-model="modal_payment.discount" />
              </div>

              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full">
                <small>Payment Date/付款日期</small>
                <datepicker :monday-first="true" placeholder="Payment Date/付款日期" class="w-full inputcss"
                  v-model="modal_payment.payment_date2" format="yyyy-MM-dd"
                  @input="modal_payment.payment_date = fixDate($event)"></datepicker>
              </div>
              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full">
                <vs-input class="w-full inputcss" type='number' label-placeholder="Paid/付款"
                  v-model="modal_payment.amount" />
              </div>



              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full" v-show="modal_payment.mode !== 'extra'">
                <vs-input type="number" class="w-full inputcss" label-placeholder="Balance/剩"
                  v-model="modal_payment.remaining_loan" />
              </div>

              <div class="vx-col mb-3 lg:w-1/2 md:w-1/2 w-full">
                Status
                <vs-input style="margin-top: 0px;" :style="modal_payment.amount > 0 ? 'color:cadetblue' : 'color:red'"
                  type="text" class="w-full inputcss" label-placeholder="Status"
                  v-text="modal_payment.amount > 0 ? 'PAID' : 'ONGOING'" />
              </div>



            </div>
            <hr class="mb-3 mt-3">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="mb-2" @click="modal_payment_button">{{ modal_payment.mode == 'edit' ? 'Update' : 'Pay'
                }}</vs-button>
              </div>
            </div>
          </vs-popup>

          <vs-popup title="Edit Extra Payment" :active.sync="flag_extraPayment">
            <div class="vx-row">
              <div class="vx-col mb-3 w-full">
                <datepicker :monday-first="true" placeholder="Date" class="w-full inputcss"
                  v-model="edited_extra.paid_date" format="yyyy-MM-dd" @input="edited_extra.paid_date = fixDate($event)">
                </datepicker>
              </div>
              <div class="vx-col mb-3 w-full">
                <vs-input class="w-full" label-placeholder="Amount" v-model="edited_extra.paid_amount" />
              </div>
              <div class="vx-col mb-3 w-full">
                <vs-select label="Status" autocomplete v-model="edited_extra.status">
                  <vs-select-item value="ACTIVE" text="ACTIVE" />
                  <vs-select-item value="VOID" text="VOID" />
                </vs-select>
                <!-- <vs-input class="w-full" label-placeholder="Status" v-model="edited_extra.status" /> -->
              </div>
            </div>
            <hr class="mb-3 mt-3">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="mb-2 mr-2" size="small" color="success" type="filled"
                  @click="updateExtra">Update</vs-button>
                <vs-button class="mb-2" size="small" type="filled" @click="closeExtraPayment">Close</vs-button>
              </div>
            </div>
          </vs-popup>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import imageCompressor from 'vue-image-compressor'
import { parse } from 'path';
import { mapState } from 'vuex';

export default {
  name: 'Loan_Installment',
  props: {
    loan_uuid: {
      type: String,
      default: '0'
    },
  },
  components: {
    Datepicker,
    vueDropzone: vue2Dropzone,
    imageCompressor,
  },
  data() {
    return {
      isSuperAdmin: true,
      edited_extra: {
        id: '',
        installment_id: '',
        loan_uuid: '',
        paid_amount: '',
        paid_date: '',
        status: ''
      },
      flag_extraPayment: false,
      complete_counter: 0,
      dropzoneOptions: {
        // url: "https://httpbin.org/post",
        url: process.env.VUE_APP_GLOBALURL + '/pictures',
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxThumbnailFilesize: 1,
        maxFilesize: 11,
        maxFiles: 6,
        parallelUploads: 1,
        autoDiscover: false,
        uploadMultiple: true,
        autoProcessQueue: true,
        // autoProcessQueue: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        // forceFallback: true,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: "Bearer " + sessionStorage.getItem('accessToken')
        },
        addRemoveLinks: true
      },
      picture_list: [],
      queue_list: 0,

      flag_new: true,
      flag_edit: false,
      flag_log_history: false,
      flag_empty_installment: false,
      flag_showImage: false,

      loan_info: {
        account_no: '',
        myDate: new Date(),
        loan_date: moment(new Date()).format('YYYY-MM-DD'),
        loan_status: '',
        loan_collector: '',
        site_visit: '',
        payment_method: '',
        bank_account: '',
        loan_amount: '',
        loan_deposit: '0',
        loan_process_fee: '0',
        loan_capital: '',
        loan_settlement: '',
        remark: '',
      },

      installment: {
        balance: '',
        created_at: '',
        created_by: '',
        day_term: '',
        deleted_at: '',
        deleted_by: '',
        id: '',
        installment_json: '',
        loan_uuid: '',
        pay_per_term: '',
        start_date: '',
        status: 'ONGOING',
        term: '',
        type: false,
        updated_at: '',
        updated_by: '',
        installment_start_date: '',
        auto_generate: true,
      },

      loading_log: true,
      log_history: [],
      advance_insert_terms_counter: 0,
      hidden_term_detail: '',
      hidden_index: '',

      installment_terms: [],
      backup_installment_terms: [],
      original_installment_details: [],
      show_all_terms: false,

      flag_save_installment: false,
      flag_payment: false,

      viewed_image_url: '',

      paymentModal_title: '',
      flag_paymentModal: false,
      flag_editpaymentModal: false,

      backup_loan_info_data: {

      },

      modal_payment: {
        index: '',
        id: '',
        due_date: '',
        amount_due: '',
        interest: '',
        discount: '',
        payment_date2: '',
        payment_date: '',
        amount: '',
        api_mode: '',
        mode: '',
        remaining_loan: '0',
      },

      bonus_list: [],
    }
  },
  watch: {
    loan_uuid() {
      console.log('loan uuid from watch', this.loan_uuid)
      let self = this
      this.resetall()
      if (this.loan_uuid !== 'new') {
        this.load_detail(this.loan_uuid)
        this.load_image(this.loan_uuid)

        setTimeout(function () {
          self.load_installment(self.loan_uuid)
          self.load_bonus(self.loan_uuid)
        }, 1000)
      }
    },
    'installment.installment_start_date'() {
      this.generateInstallmentSchedule()
    },
    'installment.auto_generate'(val) {
      if (!val) {
        this.backup_installment_terms = JSON.parse(JSON.stringify(this.installment_terms));
      }
      else {
        this.installment_terms = JSON.parse(JSON.stringify(this.backup_installment_terms));
        this.backup_installment_terms = []
      }
    },
    'installment.type'(val) {
      this.generateInstallmentSchedule()
    }
  },
  computed: {
    ...mapState([
      'percentage',
    ]),
    flagDisabled() {
      return !this.flag_empty_installment && !this.flag_new
    },
    permissions() {
      return this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions
        ? this.$store.state.AppActiveUser.permissions
        : [];
    },
    permissions_create() {
      return this.hasPermission('031');
    },
    permissions_list() {
      return this.hasPermission('032');
    },
    permissions_update() {
      return this.hasPermission('033');
    },
    permissions_delete() {
      return this.hasPermission('034');
    },
    largeScreenWidth() {
      if (window.innerWidth > 575) {
        return true
      }
      else
        return false
    },
    compute_total_interest() {
      let amount = 0
      this.log_history.forEach(function (item) {
        amount += parseFloat(item.interest || 0)
      })
      return amount.toFixed(2)
    },
    compute_total_discount() {
      let amount = 0
      this.log_history.forEach(function (item) {
        amount += parseFloat(item.discount || 0)
      })
      return amount.toFixed(2)
    },
    compute_profit_percentage() {
      return (parseFloat(this.compute_profit) * parseFloat(this.percentage) / 100).toFixed(2)
    },
    compute_profit() {
      return (parseFloat(this.compute_total_debit) - parseFloat(this.compute_total_credit)).toFixed(2)
    },
    compute_total_credit() {
      let amount = 0
      this.log_history.forEach(function (item) {
        amount += parseFloat(item.credit || 0)
      })
      return amount.toFixed(2)
    },
    compute_total_debit() {
      let amount = 0
      this.log_history.forEach(function (item) {
        amount += parseFloat(item.debit || 0)
      })
      return amount.toFixed(2)
    },
    compute_loan_info() {
      return sessionStorage.getItem('loan_info')
    },
    user_info() {
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    customers() {
      return this.$store.state.customerManagement.customers
    },
    compute_settlement() {
      let index = this.modal_payment.index
      let amount = 0
      if (index > 0 && this.modal_payment.mode !== 'settlement') {
        amount = parseFloat(this.modal_payment.amount_due || 0)
      }
      else if (index > 0 && this.modal_payment.mode == 'settlement') {
        if (this.installment_terms[index - 1] && this.installment_terms[index - 1].remaining_loan) {
          amount = parseFloat(this.installment_terms[index - 1].remaining_loan || 0)
        }
        else amount = 0
      }
      else {
        amount = parseFloat(this.loan_info.loan_settlement || 0)
      }

      return amount.toFixed(2)
    },
    initialAmt() {
      let index = parseInt(this.modal_payment.index)
      if (this.modal_payment.index == '0' || this.modal_payment.index == 0) {
        return parseFloat(this.loan_info.loan_settlement || 0).toFixed(2)
      }
      else {
        if (this.installment_terms[index - 1] && this.installment_terms[index - 1].remaining_loan) {
          return parseFloat(this.installment_terms[index - 1].remaining_loan || 0).toFixed(2)
        }
        else return '0.00'
      }
    }
  },
  methods: {
    hasPermission(permissionCode) {
      return this.permissions.includes('*') || this.permissions.includes(permissionCode);
    },
    resetall() {
      this.picture_list = []
      this.queue_list = 0

      this.flag_edit = false
      this.flag_log_history = false
      this.flag_empty_installment = false
      this.flag_showImage = false

      this.loan_info = {
        account_no: '',
        myDate: new Date(),
        loan_date: moment(new Date()).format('YYYY-MM-DD'),
        loan_status: '',
        loan_collector: '',
        site_visit: '',
        payment_method: '',
        bank_account: '',
        loan_amount: '',
        loan_deposit: '0',
        loan_process_fee: '0',
        loan_capital: '',
        loan_settlement: '',
        remark: '',
      }

      this.installment = {
        balance: '',
        created_at: '',
        created_by: '',
        day_term: '',
        deleted_at: '',
        deleted_by: '',
        id: '',
        installment_json: '',
        loan_uuid: '',
        pay_per_term: '',
        start_date: '',
        status: 'ONGOING',
        term: '',
        type: false,
        updated_at: '',
        updated_by: '',
        installment_start_date: '',
        auto_generate: true
      }

      this.loading_log = true
      this.log_history = []
      this.advance_insert_terms_counter = 0
      this.hidden_term_detail = ''
      this.hidden_index = ''

      this.installment_terms = []
      this.backup_installment_terms = []
      this.original_installment_details = []
      this.show_all_terms = false

      this.flag_save_installment = false
      this.flag_payment = false

      this.viewed_image_url = ''

      this.paymentModal_title = ''
      this.flag_paymentModal = false
      this.flag_editpaymentModal = false


      this.backup_loan_info_data = {}

      this.modal_payment = {
        index: '',
        id: '',
        due_date: '',
        amount_due: '',
        interest: '',
        discount: '',
        payment_date2: '',
        payment_date: '',
        amount: '',
        api_mode: '',
        mode: '',
        remaining_loan: '',
      }
    },
    fixDate(event) {
      return moment(event).format('YYYY-MM-DD');
    },
    formatNumber(value) {
      return parseFloat(value).toFixed(2)
    },
    removeAllFiles() {
      this.$refs.myVueDropzone.removeAllFiles();
    },
    trigger_event() {
      if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
        this.$vs.loading()
        this.$refs.myVueDropzone.processQueue();
      }
    },
    sendingEvent(file, xhr, formData) {
      console.log(file, xhr, formData);
      let uuid = this.$route.params.loan_id
      formData.append("loan_uuid", uuid);
      formData.append("loan_picture", file);
    },
    afterComplete() {
      console.log('afterComplete')
      this.$refs.myVueDropzone.removeAllFiles();
      this.picture_list = []
      this.load_image(this.$route.params.loan_id)
    },
    load_image(loan_id) {
      if (!loan_id) return false
      let self = this
      const baseURI = 'pictures/list'
      let formData = new FormData();
      formData.append('loan_uuid', loan_id);
      self.picture_list = []
      self.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            // console.log('load_image',result.data.data)
            self.picture_list = result.data.data
            self.$vs.loading.close()
          }
        })
    },
    delete_image(img_id, index) {
      let self = this
      var a = confirm('Delete this?')
      if (a) {
        this.$vs.loading()
        const baseURI = 'pictures/' + img_id
        self.$http.delete(baseURI)
          .then((result) => {
            if (result.data.status == 'success') {
              this.$vs.notify({
                color: 'success',
                title: 'Image Removed',
                text: 'The selected attachment was successfully removed'
              })
              self.picture_list.splice(index, 1)
              this.$vs.loading.close()
            }
          })
      }
    },
    //image function
    view_image(image_url) {
      let self = this
      this.viewed_image_url = image_url
      self.flag_showImage = true
    },
    resetInstallment() {
      this.advance_insert_terms_counter = 0
      this.installment = {
        balance: '',
        created_at: '',
        created_by: '',
        day_term: '',
        deleted_at: '',
        deleted_by: '',
        id: '',
        installment_json: '',
        loan_uuid: '',
        pay_per_term: '',
        start_date: '',
        status: 'ONGOING',
        term: '',
        type: false,
        updated_at: '',
        updated_by: '',
        installment_start_date: '',
        auto_generate: true
      }
    },
    cancelInstallment() {
      let self = this
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Installment Plan',
        text: `You are about to cancel this installment plan?`,
        acceptText: 'Confirm',
        accept: function () {
          self.installment_terms.splice(0, self.advance_insert_terms_counter)
          self.$vs.loading()
          let flag_paid_exist = false
          if (self.installment_terms && self.installment_terms.length > 0) {
            self.installment_terms.forEach(function (item) {
              if (item.status == 'PAID') {
                flag_paid_exist = true
              }
            })
          }

          if (!flag_paid_exist) {
            // return false
            //call delete api

            let baseURI = `installments/${self.installment.id}`
            self.$http.delete(baseURI)
              .then((result) => {
                if (result.data.status == 'success') {
                  self.$vs.notify({
                    color: 'success',
                    title: 'Installment Plan Updated',
                    text: 'Installment Plan successfully cancelled'
                  })
                  self.$vs.loading.close()
                  //reset installment component
                  setTimeout(function () {
                    self.load_detail(self.loan_uuid)
                    // self.load_bonus(self.loan_uuid)
                    self.load_installment(self.loan_uuid)
                  }, 200)
                }
              })
          }
          else {
            let baseURI = `installments/${self.installment.id}`
            let formData = new FormData()
            formData.append('_method', 'PUT')
            formData.append('status', 'CANCELLED');
            self.$http.post(baseURI, formData)
              .then((result) => {
                if (result.data.status == 'success') {
                  self.$vs.notify({
                    color: 'success',
                    title: 'Installment Plan Updated',
                    text: 'Installment Plan successfully cancelled'
                  })
                  self.$vs.loading.close()

                  setTimeout(function () {
                    self.update_installment_term_status('VOID')
                  }, 200)
                }
              })
          }
        }
      })
    },
    update_installment_term_status(action) {
      let self = this
      let new_array = []
      self.installment_terms.forEach(function (item) {
        // if(item.status !== 'PAID'){
        new_array.push(item.id)
        // }
      })

      if (new_array.length > 0) {
        self.$vs.loading()

        let baseURI = 'installment_terms/update_status'
        let formData = new FormData()
        formData.append('term_ids', new_array);
        formData.append('status', action);
        self.$http.post(baseURI, formData)
          .then((result) => {
            if (result.data.status == 'success') {

              if (action == 'VOID') {
                let baseURI3 = `loans/${self.loan_uuid}`
                let formData3 = new FormData()
                formData3.append('_method', 'PUT')
                formData3.append('loan_status', 'ACTIVE')
                self.$http.post(baseURI3, formData3)
                  .then((result) => {
                    if (result.data.status == 'success') {
                      self.$vs.notify({
                        color: 'success',
                        title: 'Installment Plan',
                        text: 'Installment Plan successfully ' + action
                      })
                      self.$vs.loading.close()
                      setTimeout(function () {
                        self.load_detail(self.loan_uuid)
                        self.load_installment(self.loan_uuid)
                      }, 250)
                    }
                  })

              }
              else {
                self.$vs.notify({
                  color: 'success',
                  title: 'Installment Plan',
                  text: 'Installment Plan successfully ' + action
                })
                self.$vs.loading.close()
                setTimeout(function () {
                  self.load_detail(self.loan_uuid)
                  self.load_installment(self.loan_uuid)
                }, 250)
              }
            }
          })
      }


    },
    saveInstallment() {
      let self = this
      //step 2
      const baseURI = 'installments'
      console.log(self.installment_terms, self.advance_insert_terms_counter)
      self.installment_terms.splice(0, self.advance_insert_terms_counter)

      let formData = new FormData();
      formData.append('pay_per_term', self.installment.pay_per_term);
      formData.append('term', self.installment.term);
      formData.append('day_term', self.installment.day_term);
      formData.append('start_date', self.installment.start_date);
      formData.append('balance', self.installment.balance);
      formData.append('type', self.installment.type ? 'PP' : 'REGULAR');
      formData.append('status', self.installment.status);
      formData.append('installment_json', JSON.stringify(self.installment_terms));
      formData.append('loan_uuid', self.loan_uuid);


      console.log('pay_per_term', self.installment.pay_per_term);
      console.log('term', self.installment.term);
      console.log('day_term', self.installment.day_term);
      console.log('start_date', self.installment.start_date);
      console.log('balance', self.installment.balance);
      console.log('type', self.installment.type ? 'PP' : 'REGULAR');
      console.log('status', self.installment.status);
      console.log('installment_json', JSON.stringify(self.installment_terms));
      console.log('loan_uuid', self.loan_uuid);
      console.log('installment_json', self.installment.installment_json);
      // return false
      self.flag_save_installment = true


      self.$vs.loading()
      self.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Installment Plan',
              text: 'Installment Plan successfully created'
            })

            self.$vs.loading.close()
            self.flag_save_installment = false
            self.load_detail(self.loan_uuid)
            // self.load_bonus(self.loan_uuid)
            self.load_installment(self.loan_uuid)
          }
        })
        .catch((err) => {
          if (err.logout) {
            self.$vs.loading.close()
            self.$vs.notify({
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              title: err.msg
            })
            sessionStorage.removeItem('accessToken')
            sessionStorage.removeItem('user')
            self.$router.push('/pages/login').catch(() => { })
          }
        })
    },
    extend_pp() {
      let self = this
      let counter = 5

      for (let a = 0; a < counter; a++) {
        let last_date = this.installment_terms[this.installment_terms.length - 1].due_date

        const baseURI = 'installment_terms'
        let formData = new FormData();
        formData.append('installment_id', this.installment.id)
        formData.append('due_date', moment(last_date, 'YYYY-MM-DD').add(parseInt(this.installment.day_term), 'days', true).format("YYYY-MM-DD"))
        formData.append('installment_amount', this.installment.pay_per_term)

        formData.append('late_charge', '')
        formData.append('discount', '')
        formData.append('paid_amount', '')
        formData.append('remaining_loan', '0')

        formData.append('status', 'ONGOING');

        this.$http.post(baseURI, formData)
          .then((result) => {
            if (result.data.status == 'success') {
              // window.location.reload();
            }
          })

        this.installment_terms.push({
          status: 'ONGOING',
          due_date: moment(last_date, 'YYYY-MM-DD').add(parseInt(this.installment.day_term), 'days', true).format("YYYY-MM-DD"),
          installment_amount: '',
          late_charge: '',
          discount: '',
          paid_amount: '',
          paid_date: '',
          remaining_loan: '0'
        })
      }

      this.installment_terms.splice(0, this.advance_insert_terms_counter)

      const baseURI = 'installments/' + this.installment.id
      let formData = new FormData();
      formData.append('installment_json', JSON.stringify(this.installment_terms));
      formData.append('_method', 'PUT');

      self.$vs.loading()
      this.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            // window.location.reload();
            self.$vs.loading.close()
            self.load_detail(self.loan_uuid)
            // self.load_bonus(self.loan_uuid)
            self.load_installment(self.loan_uuid)
          }
        })
    },
    extra_payment() {
      let self = this
      self.paymentModal_title = 'Extra Payment'

      self.modal_payment.index = 0
      self.modal_payment.id = 0
      self.modal_payment.due_date = ''
      self.modal_payment.amount_due = ''
      self.modal_payment.interest = ''
      self.modal_payment.discount = ''
      self.modal_payment.payment_date2 = new Date()
      self.modal_payment.payment_date = moment(new Date()).format('YYYY-MM-DD')
      self.modal_payment.amount = ''
      self.modal_payment.api_mode = 'extra'
      self.modal_payment.mode = 'extra'

      self.flag_paymentModal = true
    },
    deleteInstallment(item, index, purpose) {
      let self = this
      console.log(item, index, purpose)

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete this installment term?`,
        acceptText: 'Confirm',
        accept: function () {
          let baseURI = 'installment_terms/update_status'
          let formData = new FormData()
          self.$vs.loading()
          formData.append('term_ids', item.id);
          formData.append('status', 'VOID');
          self.$http.post(baseURI, formData)
            .then((result) => {
              if (result.data.status == 'success') {
                self.$vs.notify({
                  color: 'success',
                  title: 'Installment Term',
                  text: 'Installment term successfully void'
                })
                self.$vs.loading.close()
                self.load_installment(self.loan_uuid)
              }
              else {
                self.$vs.loading.close()
              }

            })
        }
      })
    },
    openPaymentModal(item, index, purpose) {
      console.log(index, item)
      let temp = this.installment_terms[index]
      // let firstflag = false
      // this.installment_terms.forEach(function(loan,index2){
      //   if(loan.status == 'ONGOING' && !firstflag){
      //     temp = loan
      //     index = index2
      //     firstflag = true
      //   }
      // })

      let self = this
      if (purpose == 'edit') {
        self.modal_payment.api_mode = 'update'
        self.paymentModal_title = 'Edit ' + temp.due_date + ' Installment'
      }
      else if (purpose == 'settlement') {
        self.modal_payment.api_mode = 'settlement'
        self.paymentModal_title = 'Settlement for this installment'
      }
      else {
        self.modal_payment.api_mode = 'new'
        self.paymentModal_title = 'Payment for ' + temp.due_date
      }

      self.modal_payment.index = index
      self.modal_payment.id = temp.id
      self.modal_payment.due_date = temp.due_date
      self.modal_payment.amount_due = parseFloat(temp.installment_amount)
      self.modal_payment.interest = parseFloat(temp.late_charge) || ''
      self.modal_payment.discount = parseFloat(temp.discount) || ''
      self.modal_payment.payment_date2 = temp.paid_date !== '' ? new Date(moment(temp.paid_date, 'YYYY-MM-DD')) : new Date()
      self.modal_payment.payment_date = temp.paid_date || moment(new Date()).format('YYYY-MM-DD')
      self.modal_payment.amount = parseFloat(temp.paid_amount) || ''

      self.modal_payment.mode = purpose

      self.modal_payment.remaining_loan = parseFloat(temp.remaining_loan || 0) || '0'

      // self.flag_editpaymentModal = false
      self.flag_paymentModal = true
    },
    full_payment() {
      let self = this
      self.paymentModal_title = 'Settlement for this installment'

      self.modal_payment.index = self.hidden_index
      self.modal_payment.id = self.hidden_term_detail.id
      self.modal_payment.due_date = self.hidden_term_detail.due_date
      self.modal_payment.amount_due = self.hidden_term_detail.installment_amount
      self.modal_payment.interest = ''
      self.modal_payment.discount = ''
      self.modal_payment.payment_date2 = new Date()
      self.modal_payment.payment_date = moment(new Date()).format('YYYY-MM-DD')
      self.modal_payment.amount = ''
      self.modal_payment.api_mode = 'settlement'
      self.modal_payment.mode = 'settlement'

      self.flag_paymentModal = true
    },
    editExtra(index) {
      this.edited_extra = {
        id: this.bonus_list[index].id,
        installment_id: this.bonus_list[index].installment_id || this.installment.id,
        loan_uuid: this.bonus_list[index].loan_uuid,
        paid_amount: this.bonus_list[index].paid_amount,
        paid_date: this.bonus_list[index].paid_date,
        status: this.bonus_list[index].status
      }
      this.flag_extraPayment = true
    },
    updateExtra() {
      let self = this
      let baseURI2 = `bonuses/${self.edited_extra.id}`
      let formData2 = new FormData()
      formData2.append('_method', 'PUT')
      formData2.append('paid_amount', self.edited_extra.paid_amount)
      formData2.append('paid_date', self.edited_extra.paid_date)
      formData2.append('status', self.edited_extra.status)
      formData2.append('installment_id', parseInt(self.edited_extra.installment_id))
      self.$http.post(baseURI2, formData2).then((result) => {
        if (result.data.status == 'success') {
          self.$vs.notify({
            text: 'Extra payment updated',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
          self.load_installment(self.loan_uuid)
          self.load_bonus(self.loan_uuid)
          self.closeExtraPayment()
        }
      })
    },
    closeExtraPayment() {
      this.edited_extra = {
        id: '',
        installment_id: '',
        loan_uuid: '',
        paid_amount: '',
        paid_date: '',
        status: ''
      }
      this.flag_extraPayment = false
    },
    removeExtra(bonus_id) {
      let self = this
      let baseURI = `bonuses/update_status`
      let new_array = []
      new_array.push(bonus_id)

      let formData = new FormData()
      formData.append('bonus_ids', new_array);
      formData.append('status', 'VOID');

      self.$vs.loading()
      self.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            self.$vs.notify({
              title: 'Extra payment voided',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            })

            self.load_installment(self.loan_uuid)
            self.load_bonus(self.loan_uuid)
          }
          self.$vs.loading.close()
        })
    },
    additional_payment() {
      let self = this
      let baseURI = `bonuses`
      let formData = new FormData()
      formData.append('loan_uuid', self.loan_uuid)
      formData.append('installment_id', self.installment.id)
      formData.append('paid_amount', self.modal_payment.amount);
      formData.append('paid_date', self.modal_payment.payment_date);

      console.log('extra payment', self.modal_payment.amount, self.modal_payment.payment_date, self.loan_uuid)
      // return false

      self.$vs.loading()
      self.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            // console.log('add bonus successful')
            self.$vs.notify({
              title: 'Bonus',
              text: 'Extra payment added',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            })

            // self.load_installment(self.loan_uuid)
            self.load_bonus(self.loan_uuid)
          }

          self.flag_paymentModal = false
          self.$vs.loading.close()
        })
    },
    modal_payment_button() {
      let self = this

      if (self.modal_payment.api_mode == 'extra') {
        this.additional_payment()
      }
      else {
        console.log('not extra payment')
        // return false
        // if(this.installment_terms[this.modal_payment.index].remaining_loan !== '' && this.modal_payment.api_mode !== 'update'){

        //   this.modal_payment.id = this.installment_terms[this.modal_payment.index + 1].id
        //   this.modal_payment.due_date = this.installment_terms[this.modal_payment.index + 1].due_date
        //   this.modal_payment.amount_due = this.installment_terms[this.modal_payment.index + 1].installment_amount            
        // }

        //execute
        let baseURI = 'installment_terms/' + this.installment_terms[self.modal_payment.index].id;
        let formData = new FormData()

        let payment_amount = 0
        payment_amount = parseFloat(self.modal_payment.amount || 0)

        // if(payment_amount == 0){
        // this.modal_payment.id = this.installment_terms[this.modal_payment.index].id
        // this.modal_payment.due_date = this.installment_terms[this.modal_payment.index].due_date
        // this.modal_payment.amount_due = this.installment_terms[this.modal_payment.index].installment_amount
        // }

        let installment_amt = parseFloat(self.modal_payment.amount_due || 0).toFixed(2)
        if (self.modal_payment.mode == 'settlement') {
          installment_amt = self.compute_settlement
        }

        let isPaid = false
        if (parseFloat(self.modal_payment.discount) > 0 || payment_amount > 0) {
          isPaid = true
        }

        formData.append('_method', 'PUT')
        formData.append('due_date', self.modal_payment.due_date)
        formData.append('installment_amount', installment_amt)
        formData.append('late_charge', parseFloat(self.modal_payment.interest || 0).toFixed(2))
        formData.append('paid_amount', payment_amount.toFixed(2))
        formData.append('paid_date', (isPaid ? self.modal_payment.payment_date : ''))
        formData.append('discount', parseFloat(self.modal_payment.discount || 0).toFixed(2))
        formData.append('remaining_loan', parseFloat(self.modal_payment.remaining_loan || 0).toFixed(2))
        formData.append('status', (isPaid ? 'PAID' : 'ONGOING'))

        var obj = {
          due_date: self.modal_payment.due_date,
          installment_amount: installment_amt,
          late_charge: parseFloat(self.modal_payment.interest || 0).toFixed(2),
          paid_amount: payment_amount.toFixed(2),
          paid_date: (isPaid ? self.modal_payment.payment_date : ''),
          discount: parseFloat(self.modal_payment.discount || 0).toFixed(2),
          remaining_loan: parseFloat(self.modal_payment.remaining_loan || 0).toFixed(2),
          status: (isPaid ? 'PAID' : 'ONGOING')
        }

        console.log(baseURI, payment_amount, obj, self.modal_payment.mode)
        // return false

        self.$vs.loading()

        self.$http.post(baseURI, formData)
          .then((result) => {
            if (result.data.status == 'success') {
              // console.log(result.data, 'make payment')
              if (isPaid && self.modal_payment.mode == 'settlement' && parseFloat(self.modal_payment.remaining_loan || 0) <= 0) {
                self.update_installment_term_status('PAID')

                self.completeAll()
              }
              else {
                if (isPaid) {
                  self.$vs.notify({
                    title: 'Installment',
                    text: `Payment ${self.modal_payment.api_mode == 'update' ? 'updated' : 'received'}!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                  })

                  self.load_installment(self.loan_uuid)
                }
                else {
                  self.$vs.notify({
                    title: 'Installment',
                    text: 'Payment cancelled!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                  })
                }
                // self.$notify({
                //   group: 'app',
                //   title: 'Payment received!',
                //   type: 'success'
                // });
                // self.load_detail(self.loan_account)
                self.load_installment(self.loan_uuid)
                // self.load_image(self.loan_account)
              }
              // self.closePaymentModal()
              self.flag_paymentModal = false
              self.$vs.loading.close()
            }
            else {
              self.flag_paymentModal = false
              self.$vs.loading.close()
            }
          })
      }
    },
    total_tobe_paid(amt_due, interest, discount) {
      let a = parseFloat(amt_due)
      let b = parseFloat(interest || 0)
      let c = parseFloat(discount || 0)

      return (a + b - c).toFixed(2)
    },
    load_detail(loan_id) {
      let self = this
      const baseURI = 'loans/' + loan_id
      self.$vs.loading()
      self.$http.get(baseURI)
        .then((result) => {
          self.$vs.loading.close()
          console.log('loans result', result)
          if (result.data.status == 'success') {
            self.loan_info = result.data.data

            self.flag_edit = false
            self.flag_new = false
          }
          else {
            self.flag_edit = true
          }
        }).catch(err => {
          if (err.logout) {
            self.$vs.loading.close()
            self.$vs.notify({
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              title: err.msg
            })
            sessionStorage.removeItem('accessToken')
            sessionStorage.removeItem('user')
            self.$router.push('/pages/login').catch(() => { })
          }
          console.error(err, 'customerManagement/fetchCustomers')
        })
    },
    load_bonus(loan_id) {
      let self = this
      const baseURI = 'bonuses/list'
      let formData = new FormData();
      formData.append('loan_uuid', loan_id);
      this.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            if (this.user_info.role == 'DEVELOPER') {
              self.bonus_list = result.data.data
            }
            else {
              self.bonus_list = result.data.data.filter((val) => {
                return val.status == 'ACTIVE'
              });
            }

            if (self.bonus_list.length > 0) {
              result.data.data.forEach(function (item) {
                if (item.status !== 'ACTIVE') {

                }
                else {
                  self.log_history.push({
                    type: 'Extra',
                    date: item.paid_date,
                    interest: '0.00',
                    discount: '0.00',
                    credit: '0.00',
                    debit: item.paid_amount,
                    remaining_loan: '0.00',
                    created_at: item.created_at
                  })
                }

              })
            }
          }
        })
    },
    load_installment(loan_id) {
      let self = this
      this.installment_terms = []
      this.backup_installment_terms = []
      this.log_history = []
      this.resetInstallment()
      //store in log history
      self.log_history.unshift({
        credit: self.loan_info.loan_capital,
        debit: '',
        type: (self.installment.type == false ? 'REGULAR' : 'PP'),
        date: self.loan_info.loan_date,
        interest: '',
        discount: '',
        remaining_loan: '0',
        created_at: self.loan_info.created_at
      })

      const baseURI = 'installments/list'
      let formData = new FormData()
      formData.append('loan_uuid', loan_id)
      self.$http.post(baseURI, formData)
        .then((result) => {
          if (result.data.status == 'success') {
            console.log('get installment list', result.data)
            self.original_installment_details = result.data.data
            if (result.data.data.length == 0) {
              // no installment data
              self.flag_empty_installment = true
              self.flag_log_history = false
            }
            else {
              // self.flag_empty_installment = false
              result.data.data.forEach(function (item) {
                // console.log(self.installment_terms, 'halo there')
                if (item.status == 'CANCELLED') {
                  self.flag_empty_installment = true
                  item.terms.forEach(function (term) {
                    if (term.status == 'PAID' && term.paid_date !== '') {
                      term.className = 'border-success'
                      term.classText = 'text-success'
                      term.type = item.type
                      // console.log('is canceled')
                      self.advance_insert_terms_counter += 1
                      self.installment_terms.push(term)
                      self.backup_installment_terms.push(term)
                      //store in log history
                      self.log_history.push({
                        credit: '',
                        debit: term.paid_amount,
                        type: item.type,
                        date: term.paid_date,
                        interest: term.late_charge,
                        discount: term.discount,
                        remaining_loan: term.remaining_loan,
                        created_at: term.created_at
                      })
                    }
                    // console.log(self.installment_terms.length,'cancelled')
                  })
                }

                else if (item.status == 'ONGOING' || item.status == 'COMPLETE') {
                  self.flag_edit_installment = false
                  self.flag_empty_installment = false
                  console.log(item, 'hehe')

                  self.installment.balance = item.balance
                  self.installment.created_at = item.created_at
                  self.installment.created_by = item.created_by
                  self.installment.day_term = item.day_term
                  self.installment.deleted_at = item.deleted_at
                  self.installment.deleted_by = item.deleted_by
                  self.installment.id = item.id
                  self.installment.installment_json = item.installment_json
                  self.installment.loan_uuid = item.loan_uuid
                  self.installment.pay_per_term = item.pay_per_term
                  self.installment.start_date = item.start_date
                  self.installment.status = item.status
                  self.installment.term = item.term
                  self.installment.terms = item.terms
                  self.installment.type = item.type == 'PP' ? true : false
                  self.installment.updated_at = item.updated_at
                  self.installment.updated_by = item.updated_by
                  self.installment.installment_start_date = new Date(moment(item.start_date, 'YYYY-MM-DD'))

                  let flag_onlyone = false
                  self.complete_counter = 0
                  item.terms.forEach(function (term, index) {
                    if (term.status == 'PAID' && term.paid_amount !== '' && parseFloat(term.paid_amount) > 0 || parseFloat(term.discount) > 0) {
                      self.complete_counter += 1;
                      term.className = 'border-success'
                      term.classText = 'text-success'
                      term.type = item.type

                      self.installment_terms.push(term)
                      // self.backup_installment_terms.push(term)

                      //store in log history
                      self.log_history.push({
                        credit: '',
                        debit: term.paid_amount,
                        type: item.type,
                        date: term.paid_date,
                        interest: term.late_charge,
                        discount: term.discount,
                        remaining_loan: term.remaining_loan,
                        created_at: term.created_at
                      })
                    }
                    else {
                      if (item.status !== 'COMPLETE' || item.status == 'ONGOING') {
                        // console.log(term,'eric term')
                        self.installment_terms.push(term)
                        if (!flag_onlyone) {
                          self.hidden_term_detail = term
                          self.hidden_index = index
                          flag_onlyone = true
                        }

                      }
                    }
                  })

                  setTimeout(() => {
                    if (self.complete_counter == self.installment_terms.length && item.status == 'ONGOING') {
                      self.completeAll()
                    }
                  }, 500);
                }

                self.flag_log_history = true
              })
            }
          }
        })
    },
    completeAll() {
      let self = this
      setTimeout(function () {
        let baseURI2 = `installments/${self.installment.id}`
        let formData2 = new FormData()
        formData2.append('_method', 'PUT')
        formData2.append('status', 'COMPLETE')
        self.$http.post(baseURI2, formData2)
          .then((result) => {
            if (result.data.status == 'success') {
              // console.log('update installment status to paid')

              let baseURI3 = `loans/${self.loan_uuid}`
              let formData3 = new FormData()
              formData3.append('_method', 'PUT')
              formData3.append('loan_status', 'COMPLETE')
              self.$http.post(baseURI3, formData3)
                .then((result) => {
                  if (result.data.status == 'success') {
                    // console.log('update loan status to complete')
                    self.$vs.notify({
                      title: 'Loan',
                      text: 'Loan successfully completed!',
                      iconPack: 'feather',
                      icon: 'icon-check-circle',
                      color: 'success'
                    })
                    // self.$notify({
                    //   group: 'app',
                    //   title: 'Loan successfully completed',
                    //   type: 'success'
                    // });
                    setTimeout(function () {
                      // window.location.reload();

                      self.load_installment(self.loan_uuid)
                      self.load_detail(self.loan_uuid)
                      // self.load_image(self.loan_uuid)
                      // self.$emit('refresh_page', self.loan_id)
                      // self.$root.$emit('refresh', self.loan_id);
                    }, 350)
                    // self.load_detail()
                  }
                })
              // self.load_detail()
            }
          })
      }, 500)
    },
    generateInstallmentSchedule() {
      console.log('generateInstallmentSchedule')
      let isvalid = false
      if (this.installment.type) {
        if (this.installment.pay_per_term !== '' &&
          this.installment.day_term !== '' &&
          this.installment.start_date !== '') {
          isvalid = true
        }
      }
      else {
        if (this.installment.pay_per_term !== '' &&
          this.installment.term !== '' &&
          this.installment.day_term !== '' &&
          this.installment.start_date !== '') {
          isvalid = true
        }
      }

      // console.log('isvalid',isvalid,!self.flag_empty_installment,!isvalid)
      // if(!self.flag_empty_installment)
      //   return false

      let temp = this.installment.type ? 'PP' : 'REGULAR'

      if (!isvalid)
        return false

      const clone = JSON.parse(JSON.stringify(this.backup_installment_terms));
      // console.log('this.installment.terms',this.installment.terms)
      if (this.installment.terms && this.installment.terms !== '') {
        if (clone && clone.length > 0) {
          this.installment_terms.concat(clone)
          this.installment_terms.concat(JSON.parse(JSON.stringify(this.installment.terms)))
        }
        else {
          this.installment_terms = JSON.parse(JSON.stringify(this.installment.terms))
        }
      }
      else {
        if (clone.length > 0) {
          this.installment_terms = clone
        }
        else {
          this.installment_terms = []
        }

        if (temp !== 'PP') {
          for (let a = 0; a < parseInt(this.installment.term); a++) {
            if (a == 0) {
              this.installment_terms.push({
                status: 'ONGOING',
                due_date: moment(this.installment.start_date).format('YYYY-MM-DD'),
                installment_amount: this.installment.pay_per_term,
                late_charge: '',
                discount: '',
                paid_amount: '',
                paid_date: '',
                remaining_loan: '0',
                loan_type: temp
              })
              // parseFloat(this.repayment.term) * parseFloat(this.repayment.amount)
            }
            else {
              this.installment_terms.push({
                status: 'ONGOING',
                due_date: moment(this.installment.start_date).add(parseInt(this.installment.day_term) * a, 'days', true).format("YYYY-MM-DD"),
                installment_amount: this.installment.pay_per_term,
                late_charge: '',
                discount: '',
                paid_amount: '',
                paid_date: '',
                remaining_loan: '0',
                loan_type: temp
              })
            }
          }
        }
        else {
          let counter = 5

          for (let a = 0; a < counter; a++) {
            if (a == 0) {
              this.installment_terms.push({
                status: 'ONGOING',
                due_date: moment(this.installment.start_date).format('YYYY-MM-DD'),
                installment_amount: this.installment.pay_per_term,
                late_charge: '',
                discount: '',
                paid_amount: '',
                paid_date: '',
                remaining_loan: '0',
                loan_type: temp
              })
              // parseFloat(this.repayment.term) * parseFloat(this.repayment.amount)
            }
            else {
              this.installment_terms.push({
                status: 'ONGOING',
                due_date: moment(this.installment.start_date).add(parseInt(this.installment.day_term) * a, 'days', true).format("YYYY-MM-DD"),
                installment_amount: this.installment.pay_per_term,
                late_charge: '',
                discount: '',
                paid_amount: '',
                paid_date: '',
                remaining_loan: '0',
                loan_type: temp
              })
            }
          }
        }
        // this.$forceUpdate()          
      }
      this.installment.installment_json = JSON.stringify(this.installment_terms)
      // this.highlightTable();
    },
    checkLateDate(val, status) {
      if (status == 'ONGOING') {
        if (moment(val, 'YYYY-MM-DD').isSameOrBefore(moment())) {
          // console.log(val,'yes sir')
          return 'latedate'
        }
        else {
          return ''
        }
      }
      else if (status == 'PAID') {
        return 'paid'
      }
    },
    checkLateDate2(val, status) {
      if (status == 'ONGOING') {
        if (moment(val, 'YYYY-MM-DD').isSameOrBefore(moment())) {
          // console.log(val,'yes sir')
          return true
        }
        else {
          return false
        }
      }
      else {
        return false
      }
    }
    // checkLateDate(val, status, returnValue) {
    //   if (status === 'ONGOING') {
    //     if (moment(val, 'YYYY-MM-DD').isSameOrBefore(moment())) {
    //       return returnValue;
    //     }
    //   } else if (status === 'PAID') {
    //     return 'paid';
    //   }
    //   return returnValue;
    // }
  },
  mounted() {
    let self = this
    console.log('mounted loan uuid ', this.loan_uuid)
    if (this.loan_uuid !== '' && this.loan_uuid !== 'new') {
      this.load_detail(this.loan_uuid)
      this.load_image(this.loan_uuid)

      setTimeout(function () {
        self.load_installment(self.loan_uuid)
        self.load_bonus(self.loan_uuid)
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.loan-installment .vs-tabs--btn-icon+span {
  padding-left: 0px;
  font-size: 0.95rem;
}


.w-32 {
  width: 10rem !important;
}

.disableform {
  pointer-events: none;
  opacity: 0.4;
}

.vx-card__title h4 {
  font-size: 1rem;
}

[dir] .vx-card {
  &.contact {
    min-width: 250px;
    min-height: 180px;
    box-shadow: 0px 4px 25px 0px #7B7B7B
  }
}

[dir] .dropzone {
  padding: 10px
}

.margintop {
  position: relative;
  top: -6px;
}

.img-detail .vs-popup--content {
  text-align: center;
}

.install-term .vx-card__header {
  border: 1px solid grey;
  border-bottom: none;
}

.install-term .vx-card__body {
  border: 1px solid grey;
  border-top: none;
  border-bottom: none;
}

.install-term .vx-card__footer {
  border: 1px solid grey;
  border-top: none;
}

.install-term .paid .vx-card__title h4,
.span-PAID {
  color: #00AF2F;
  font-weight: bolder;
}

.span-ONGOING {
  &.latedate {
    animation-name: example;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
}

.install-term .latedate .vx-card__title h4 {
  animation-name: example;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.inputcss input {
  border: 1px solid #4892CB !important;
}

@keyframes example {
  from {
    color: #FF8C74;
  }

  to {
    color: red;
  }
}

.attachments .vx-card__collapsible-content .vx-card__body {
  padding: .2rem;
}

.vs-textarea:disabled {
  border: 1px solid rgba(0, 0, 0, 0.2);
  opacity: .5;
  cursor: default;
  pointer-events: none;
  background-color: -internal-light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
}

.install-term {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 1rem !important;
    padding-bottom: 1px !important;
  }
}


.col-full-detail {
  &.open-item {
    .vs-collapse-item--content {
      max-height: 350px !important;
      overflow-y: scroll;
    }
  }

  .con-content--item {
    padding: 0px !important;
    // overflow-x: hidden !important;
  }
}

.vs-collapse-item--content {
  border-top: none;
  padding: 0 !important;
}

.table-full-detail thead tr {
  th {
    font-size: 1rem;
  }

}
</style>
